/**
 * Trims content to the last complete line (ending with \n).
 * Used during streaming to avoid rendering partial markdown fragments
 * like unclosed bold markers or half-formed headings.
 * Falls back to returning the full content if no newline exists yet.
 */
export const trimToLastNewline = (content: string): string => {
  const lastNewlineIndex = content.lastIndexOf('\n')

  if (lastNewlineIndex === -1) {
    return content
  }

  return content.substring(0, lastNewlineIndex + 1)
}
